module.exports = __webpack_public_path__ + "img/03.65e84c27.jpg";